import { useContext, useEffect } from 'react'
import { NavContext } from '../../context/global_context'
import { getLocalStorageData } from '../../utils/LocalStorageAccess'
import { createSearchParams } from 'react-router-dom'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import UserList from '../../components/administration/user'
import PlantList from '../../components/administration/plant'

const Administration = () => {
  const [value, dispatch] = useContext(NavContext)
  const vehicle_redirect_url = getLocalStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getLocalStorageData('vehicle'))}`
    : `/vehicles`

  useEffect(() => {
    dispatch({
      type: 'header',
      data: {
        header: 'Administration',
        sub_header: 'Here you can modify or create user and plant',
        id: '',
        show_back_btn: true,
        dtc_details: {},
        vehicle: '',
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })
  }, [])

  return (
    <Tabs variant="fullWidth" style={{ width: '100%' }}>
      <TabList style={{ fontSize: '1.25rem' }}>
        <Tab>Users</Tab>
        <Tab>Plants</Tab>
      </TabList>
      <TabPanel>
        <div className="w-full text-white ">
          {value?.header && <UserList />}
        </div>
      </TabPanel>
      <TabPanel>
        <div className="w-full text-white block">
          {value?.header && <PlantList />}
        </div>
      </TabPanel>
    </Tabs>
  )
}

export default Administration
